<template>
  <div class="new-place">
    <!-- <div class="new-place-panel">
      <div class="new-place-search">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="none"
          viewBox="0 0 32 32"
        >
          <path
            stroke="#000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M14.5 25C20.299 25 25 20.299 25 14.5S20.299 4 14.5 4 4 8.701 4 14.5 8.701 25 14.5 25zM21.924 21.925L28 28"
          />
        </svg>

        <input
          type="search"
          v-model="search"
          name="place-search"
          id="place-search"
          placeholder="Название места"
        />
        Список мест
        <div class="new-place-dropdown" v-if="filteredBySearch.length > 0 && search.length > 0">
          <div class="new-place-group">
            <h4 class="new-place-title">Места</h4>
            <div
              class="new-place-item"
              @click="setPlace(place)"
              v-for="place in filteredBySearch"
              :key="place.id"
            >
              <div
                class="new-place-item__avatar"
                :style="{ backgroundImage: 'url(' + place.cover + ')' }"
              >
              </div>
              <div class="new-place-item__content">
                <h3>{{ place.title }}</h3>
                <p>{{ place.country + ', ' + place.state }}</p>
                <div class="new-place-item__sports" v-if="place.sports">
                  <span v-for="sport in place.sports" :key="sport.id" :class="sport.color">{{
                    sport.ru
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="new-place-group" v-if="filteredByStates.length > 0">
            <h4 class="new-place-title">Города</h4>
            <div
              class="new-place-item"
              @click="setState(state)"
              v-for="state in filteredByStates"
              :key="state.id"
            >
              <div
                class="new-place-item__avatar"
                :style="{ backgroundImage: 'url(' + state.cover + ')' }"
              >
              </div>
              <div class="new-place-item__content">
                <h3>{{ state.name }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="button">{{ getChoisenPlace }}</div>
    </div>

    <LMap
      id="new-place__map"
      :zoom="zoom"
      :center="getCenter"
      :options="mapOptions"
      style="height: 100%"
      ref="newMap"
      @click="onMapClick"
    >
      <l-tile-layer
        :url="url"
        :attribution="attribution"
      />
      <v-marker-cluster>
        <l-marker
          v-for="(place, index) in places"
          :lat-lng="getPosition(place)"
          :icon="getIcon(place)"
          :key="index"
          @click="setPlace(place)"
        >
        </l-marker>
        <l-marker
          v-if="marker"
          :icon="getPlaceIcon()"
          :lat-lng="marker.position"
        />
      </v-marker-cluster>
    </LMap> -->
  </div>
</template>

<script>
// import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
// import "leaflet/dist/leaflet.css"
// import icons from "@/components/Icons/places";
// import { latLng, icon } from "leaflet";
// import VMarkerCluster from "vue2-leaflet-markercluster";
// import L from 'leaflet';

export default {
  name: 'BlockPlace',
  props: {
    icon_point: {
      type: String,
      required: false
    },
    active_place: {
      type: Object,
      require: false
    },
    active_point: {
      type: Object,
      require: false
    },
    exclude_place: {
      type: Object,
      require: false
    }
  },
  data() {
    return {
      // active: null,
      // places: [],
      // zoom: 13,
      // center: latLng(59.9308062, 30.3104669),
      // url: 'https://{s}.tile.jawg.io/jawg-sunny/{z}/{x}/{y}{r}.png?access-token=WZ50aKhG2m0zE11atv78m2AVKuxophoxxXDV1rbwYU2XmKmbgFRejg8zQArTpKDa',
      // attribution:
      //   '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      // withPopup: latLng(59.9308062, 30.3104669),
      // currentZoom: 11.5,
      // currentCenter: latLng(59.9308062, 30.3104669),
      // showParagraph: false,
      // mapOptions: {
      //   zoomSnap: 0.5,
      //   zoomControl: false
      // },
      // marker: null,
      // search: '',
    };
  },
  components: {
    // VMarkerCluster,
    // LMap,
    // "l-tile-layer": LTileLayer,
    // 'l-marker': LMarker
  },
  computed: {
    getCenter() {
      // let center = this.$store.getters.getMapCenter;
      // return center ? latLng(center) : this.center 
      return true
    },
    getEvents() {
      return this.$store.getters.getEvents;
    },
    getActiveSports() {
      return this.$store.getters.getActiveSportsNew;
    },
    getChoisenPlace() {
      return this.active ? this.active.title : 'Без места';
    },
    getCountries() {
      return this.$store.getters.getCountries
    },
    filteredBySearch() {
      return this.places.filter(
        (place) => place.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1
      );
    },
    filteredByStates() {
      return this.getCountries 
        ? this.getCountries.filter(
          country => country.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        ) 
        : [];
    },
  },
  methods: {
    getPosition(place) {
      return place
        ? {
            lat: place.latitude || place.lat,
            lng: place.longitude || place.lng,
          }
        : null;
    },
    onMapClick(e) {
      this.marker =
        {
          position: e.latlng,
        };
      this.active = {
        title: 'Выбрано место: ' + this.cutString(e.latlng.lat, 9) + ', ' + this.cutString(e.latlng.lng, 9),
      };
      this.$emit('setPosition', { latitude: e.latlng.lat, longitude: e.latlng.lng });
      this.clearPlace()
    },
    async loadData() {
      let places = await this.$store.dispatch('getPlaces', {
        search: this.search,
        sports: this.getActiveSports,
        mini: true
      });
      this.places = this.exclude_place ? places.filter(pl => pl.id !== this.exclude_place.id) : places
    },
    // getIcon(place) {
    //   let ic = place.icon ? icons[place.icon] : icons.flag;
    //   var template = [ic('#2d2c3a')].join("\n");
    //   let icon_ready = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(template);
    //   return icon({
    //     iconUrl: icon_ready,
    //     iconSize: [40, 40],
    //     iconAnchor: [20, 20]
    //     });
    // },
    // getPlaceIcon() {
    //   let point = this.icon_point ? icons[this.icon_point] : icons.flag; 
    //   var template = [point()].join("\n");
    //   let icon_ready =
    //     "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(template);
    //   return icon({
    //     iconUrl: icon_ready,
    //     iconSize: [40, 40],
    //     iconAnchor: [20, 20]
    //   });
    // },
    clearPlace() {
      this.active = null;
      this.$emit('setPlace', null);
    },
    // setPlace(place) {
    //   this.marker = null;
    //   this.$emit('setPosition', { latitude: null, longitude: null });
    //   this.active = place;
    //   this.$emit('setPlace', place);
    //   this.setCenter(place)
    // },
    cutString(val, length) {
          if (val) {
              val = val.toString();
              val = val.length > length ? val.slice(0, length).concat("...") : val;
          }
          return val;
    },
  //   async setCenter (active) {
  //     console.log(active,'active');
  //    if (active && active.place) {
  //       this.$store.dispatch('setCenter', latLng(active.place.latitude, active.place.longitude));
  //     } else if (
  //       active &&
  //       active.latitude &&
  //       active.longitude
  //     ) {
  //       this.$store.dispatch('setCenter', latLng(active.latitude, active.longitude));
  //     }
  //  }
  },
  // watch: {
  //   active_point(active) {
  //     if (active) {

  //       this.center = latLng(active.latitude, active.longitude),
  //       this.marker =
  //         {
  //           position: {lat: active.latitude, lng: active.longitude},
  //         };
  //       this.active = {
  //         title: 'Выбрано место: ' + this.cutString(active.latitude, 9) + ', ' + this.cutString(active.longitude, 9),
  //       };
  //     }
  //   }
  // },
  mounted() {
    this.active_place ? this.active = this.active_place : ''
    this.loadData();
    this.$store.dispatch('fetchCountries');
  },
};
</script>
